import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import { PlusOutlined } from "@ant-design/icons";

import { tableColumn } from 'utils';
import { TableList, ActionButton } from 'components/common';
import { PageValue } from 'components/blocks/Page';
import NavMainValue from '../NavMainValue';


const NavMainList = ({ router, columnList, defaultFilter, activeFilter, topActions, actions, navMain }) => {
  const defaultColumnList = ['title', 'path', 'page', 'sort', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    title: tableColumn('Тайтл', 'title', {
      render: (val, item) => <NavMainValue detail={item} asLink={true} isBack={true} />,
      sorter: true,
    }),
    path: tableColumn('Путь', 'path', {
      sorter: true,
    }),
    page: tableColumn('Страница', 'page', {
      render: (val, item) => <PageValue detail={val} asLink={true} isBack={true} />,
      sorter: true,
    }),
    sort: tableColumn('Сортировка', 'sort', {
      sorter: true,
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton detail={item} modelActions={actions.navMain} actions={[{ name: 'edit' }, { name: 'delete' }]} />
      ),
    }),
  };

  const [selected, setSelected] = useState([]);

  const onLoad = useCallback(
    ({ query, activeFilter }) => {
      if (activeFilter === undefined) {
        activeFilter = navMain.filter.activeFilter;
      }
      actions.navMain.listLoad({ query, activeFilter, locationChange: true });
      setSelected([]);
    },
    [navMain, actions, setSelected],
  );

  const batchDelete = (selected) => {
    actions.navMain.batchDelete({ selected });
  };

  const navAdd = () => {
    actions.navMain.showEditForm({ 
      show: true, 
      preventLoadDetail: true
    });
  };

  return (
    <TableList
      location={router.location}
      model={navMain}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={[
        <Button type="primary" icon={<PlusOutlined/>} onClick={navAdd}>
          Добавить
        </Button>
      ]}
      showSearch={true}
      selected={selected}
      rowSelection={{
        selectedRowKeys: selected,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelected(selectedRowKeys.slice());
        },
      }}
      rowActions={[
        {
          title: 'Удалить',
          icon: 'delete',
          action: (selected) => batchDelete(selected),
        },
      ]}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  navMain: state.navMain,
});

const mapDispatch = (dispatch) => ({
  actions: {
    navMain: dispatch.navMain,
  },
});

export default connect(mapState, mapDispatch)(NavMainList);
